import React, { FC } from 'react';
import ICompanyFilter from './ICompanyFilter';
import { ISelectOption } from '../../../../utils/types';
import MultiSelectFilter from '../multi-select-filter/MultiSelectFilter';

const CompanyFilter: FC<ICompanyFilter> = ({ options, placeholder, disabled, setFilters }) => {
	const filterKey = 'companyFilter';
	const propertyName = 'company';

	const onMultiSelectValueChange = (value: ISelectOption[]) => {
		if (!value.length) {
			setFilters((prev: any) => ({
				...prev,
				[filterKey]: (dataRecord: any) => true,
			}));
			return;
		}

		setFilters((prev: any) => ({
			...prev,
			[filterKey]: (dataRecord: any) =>
				value.some((v) => {
					return v.value === dataRecord[propertyName].id;
				}),
		}));
	};

	return (
		<MultiSelectFilter
			placeholder={placeholder || 'Company'}
			options={options || []}
			onChange={onMultiSelectValueChange}
			isTagStyledList={false}
			disabled={disabled}
		/>
	);
};

export default CompanyFilter;
